import { Badge } from '@react-apps/design-system';

/**
 * Badge "Depreciada" com a data, para roles/features/formas de perk que pararam
 * de ser concedidas (quem já tem mantém). Não renderiza nada quando `null` —
 * assim dá para colocar direto ao lado do nome sem condicional em cada uso.
 */
export function DeprecatedBadge({
  deprecatedAt,
}: {
  deprecatedAt: string | null;
}) {
  if (!deprecatedAt) return null;
  const date = new Date(deprecatedAt);
  const label = Number.isNaN(date.getTime())
    ? 'Depreciada'
    : `Depreciada em ${date.toLocaleDateString('pt-BR')}`;
  return <Badge variant="warning">{label}</Badge>;
}
